var React = require('react');

function BannerBandFlipped (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#F2F2F2","d":"M1440,70C1331,28.89,1043.66,0,715.8,0C388.94,0,109.67,29.08,0,70H1440z"}));
}

BannerBandFlipped.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 1440 70","enableBackground":"new 0 0 1440 70","xmlSpace":"preserve","preserveAspectRatio":"none"};

module.exports = BannerBandFlipped;

BannerBandFlipped.default = BannerBandFlipped;
